import React from 'react';
import classnames from 'classnames';
import Headline from './headline';

export default ({ isActive, seconds, actionOk }) => {
    let modalToggle = classnames('modal-dialog', 'hidden', {
        show: isActive
    });
    return (
        <div className={`modal modal--session`}>
            <div className={modalToggle}>
                <div className="modal-dialog__background" />
                <div className="modal-dialog__content">
                    <div className="modal-dialog__inner">
                        <Headline
                            title="Session Expiration Warning"
                            tagValue="5"
                        />
                        <p>Your session will expire in {seconds} seconds.</p>
                        <p>Click on OK to continue your session.</p>

                        <button
                            className="btn align-right modal-dialog__close"
                            onClick={actionOk}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/ui/modal-session.js